import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import theme from '~/style/theme'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: ${props => props.size};
  max-height: ${props => props.size};
`

const SVG = styled.svg`
  cursor: pointer;
`

const PlusIcon = ({ color, size }) => {
  return (
    <Container size={size}>
      <SVG
        width={size}
        // xmlns="http://www.w3.org/2000/svg"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
        height={size}
        viewBox="0 0 14 14"
        version="1.1"
      >
        <g
          id="desktop"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g
            id="New-flow_02_multiple-tickets-(1)"
            transform="translate(-279.000000, -402.000000)"
            stroke={color}
            strokeWidth="2"
          >
            <g id="Group-11-Copy" transform="translate(270.000000, 393.000000)">
              <g id="Group-3">
                <g id="Group-10" transform="translate(10.000000, 10.000000)">
                  <path d="M6,0 L6,12" id="Line-7" />
                  <path
                    d="M6,0.285714286 L6,11.7142857"
                    id="Line-7"
                    transform="translate(6.000000, 6.000000) rotate(-270.000000) translate(-6.000000, -6.000000) "
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </SVG>
    </Container>
  )
}

PlusIcon.defaultProps = {
  color: theme.colors.text.inputPlaceholder,
  size: '15px'
}

PlusIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string
}

export default PlusIcon
